import React from "react";
import {Card, Table as BootstrapTable} from "react-bootstrap";
import CardBodyContentContainer from "../../../common/styles/CardBodyContentContainer";
import Spacer from "../../../common/Spacer";
import styled, {keyframes} from "styled-components";
import BooksitoutImages from "../../../images/BooksitoutImages";
import LoadingBar from "../../../common/LoadingBar";
import ColSpacer from "../../../common/styles/ColSpacer";
import ColorConfig from "../../../config/ColorConfig";
import breakpoints from "../../../config/Breakpoints";
import {Author} from "../../../common/Author";

const BookIsbnCardLoading = () => {
    return (
        <Card>
            <CardBodyContentContainer height={400}>

                <TopLoadingBar/>

                <Container>
                    <BookCoverContainer>
                        <BookCover src={BooksitoutImages.Placeholder.bookCoverLoading} alt={'로딩중'}/>
                    </BookCoverContainer>

                    <BookInfoContainer>
                        <div className={`d-flex flex-column flex-md-row`}>
                            <BookTitle>
                                <span className={'d-none d-md-block'}>
                                    <LoadingBar size={12}/>
                                </span>

                                <span className={'d-md-none'}>
                                    <LoadingBar size={9}/>
                                </span>
                            </BookTitle>
                        </div>

                        <Author>
                            <LoadingBar size={7}/>
                        </Author>

                        <Spacer/>

                        <span className={'pt-4 pt-md-0'}/>

                        <Table hover>
                            <tbody>
                            <tr>
                                <InfoTitle>출판사</InfoTitle>
                                <InfoContent><LoadingBar size={3}/> <ColSpacer size={5}/></InfoContent>
                            </tr>

                            <tr>
                                <InfoTitle>페이지</InfoTitle>
                                <InfoContent><LoadingBar size={3}/> <ColSpacer size={5}/></InfoContent>
                            </tr>

                            <tr>
                                <InfoTitle>출판년도</InfoTitle>
                                <InfoContent><LoadingBar size={3}/> <ColSpacer size={5}/></InfoContent>
                            </tr>
                            </tbody>
                        </Table>

                        <Spacer/>

                        <div>
                        </div>
                    </BookInfoContainer>
                </Container>
            </CardBodyContentContainer>
        </Card>
    )
}

const fillAnimation = keyframes`
    from {
        width: 0%;
    }
    to {
        width: 100%;
    }
`;

// Style the loading bar
const TopLoadingBar = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    height: 4px; /* Adjust the height as needed */
    background-color: ${ColorConfig.Primary}; /* Change to your desired color */
    animation: ${fillAnimation} 8s linear forwards;
`;

const Container = styled.div.attrs({
    className: 'row'
})`
    height: 100%;
    padding: 20px;

    @media screen and (max-width: ${breakpoints.md}) {
        padding: 0;
    }
`

const BookCoverContainer = styled.div.attrs({
    className: 'col-12 col-sm-6 col-md-4 col-xl-3'
})`
    height: 100%;
    align-content: center;
`

const BookInfoContainer = styled.div.attrs({
    className: 'col-12 col-sm-6 col-md-8 col-xl-9'
})`
    padding-left: 30px;
    padding-top: 30px;

    display: flex;
    flex-direction: column;
`

const BookCover = styled.img.attrs({
    className: 'img-fluid rounded border'
})``

const BookTitle = styled.h1`
    font-size: 2rem;
    font-weight: bold;
    padding-bottom: 5px;

    @media screen and (max-width: ${breakpoints.md}) {
        font-size: 1.5rem;
    }
`

const InfoTitle = styled.td`
    background-color: var(--card-bg-color) !important;
    color: var(--text-color) !important;
    text-align: start;
    justify-content: start;

    @media screen and (max-width: ${breakpoints.md}) {
        text-align: center;
        justify-content: center;
    }
`

const InfoContent = styled.td.attrs({
    className: 'text-secondary'
})`
    background-color: var(--card-bg-color) !important;
    color: var(--text-color) !important;
    text-align: start;
    justify-content: start;

    @media screen and (max-width: ${breakpoints.md}) {
        text-align: center;
        justify-content: center;
    }
`

const Table = styled(BootstrapTable)`
    max-width: 500px;
`

export default BookIsbnCardLoading
